export function getTelegramUserId(): string {
  const telegramId = window.Telegram?.WebApp?.initDataUnsafe?.user?.id
  if (telegramId) return String(telegramId)

  // Browser fallback for development
  return 'dev-' + Math.random().toString(36).slice(2, 8)
}

export function getReferralCode(): string | null {
  // Official field (WebApp payload)
  const tgParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param

  // Legacy raw parsing (look for startapp first, then start)
  const raw = window.Telegram?.WebApp?.initData ?? ''
  const mStartApp = raw.match(/(?:^|&)startapp=([^&]*)/)
  const mStart = raw.match(/(?:^|&)start=([^&]*)/)

  // Plain browser / dev
  const url = new URLSearchParams(location.search)
  const urlStartApp = url.get('startapp')
  const urlStart = url.get('start')

  return (
    tgParam ||
    (mStartApp && decodeURIComponent(mStartApp[1])) ||
    (mStart && decodeURIComponent(mStart[1])) ||
    urlStartApp ||
    urlStart ||
    null
  )
}

export function initializeTelegram(): void {
  if (window.Telegram?.WebApp?.version) {
    window.Telegram.WebApp.onEvent?.('relaunch', () => location.reload())
    window.Telegram.WebApp.ready?.()
  }
}
